import { UserPermission } from "src/app/ui/models/domains/pbm/user/user-permission";

export class UserPermissionListFactory {
  static createUserPermissionList(payload: any): UserPermission[] {
    const userPermissionList: UserPermission[] = payload.map((item) => {
      const userPermission = new UserPermission();
      userPermission.setUserPermissionKey(item.userPermissionKey);
      userPermission.setName(item.name);
      userPermission.setCode(item.code);
      userPermission.setUserRoleType(item.userRoleType);
      return userPermission;
    });
    return userPermissionList;
  }
}
